import {
  ChangeDetectionStrategy,
  Component,
  importProvidersFrom,
} from '@angular/core';
import { RouterOutlet, Routes } from '@angular/router';
import { OktaAuthGuard } from '../../guards/okta-auth';
import { canMatchInternalUser } from '../../guards/permissions';
import { canMatchProfileComplete } from '../../guards/profileComplete';
import { WcgTableService } from '@wcg/frontend-framework';

import {
  USER_PROVIDER,
  UserManagementEffects,
  userResolver,
  UserService,
} from '@data-access/user-management';

import { EffectsModule } from '@ngrx/effects';
import {
  canMatchUseSiteServiceV2,
  negateGuard,
} from '../utils/user-management-route.util';

/**
 *
 * @PARENT LEVEL PROFILES PAGE
 *
 * */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  selector: 'wcg-profiles',
  template: `
    <div class="w-full">
      <router-outlet />
    </div>
  `,
})
export class ProfilesPageComponent {}

export const PROFILE_ROUTES: Routes = [
  {
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'people',
      },
      // V2: Contact detail page (when USER_SITE_SERVICE_V2 is ON)
      {
        canMatch: [canMatchUseSiteServiceV2],
        loadChildren: () =>
          import('./contact-detail.page').then((m) => m.CONTACT_DETAIL_ROUTES),
        path: 'contact-overview',
        title: 'Profile Information',
      },
      // V1: Contact detail page (when USER_SITE_SERVICE_V2 is OFF)
      {
        canMatch: [negateGuard(canMatchUseSiteServiceV2)],
        loadChildren: () =>
          import('../v1/pages/contact-detail-v1.page').then(
            (m) => m.CONTACT_DETAIL_V1_ROUTES,
          ),
        path: 'contact-overview',
        title: 'Profile Information',
      },
      // V2: New standalone UserComponent (when USER_SITE_SERVICE_V2 is ON)
      {
        canMatch: [
          canMatchUseSiteServiceV2,
          OktaAuthGuard,
          canMatchInternalUser,
          canMatchProfileComplete,
        ],
        loadComponent: () =>
          import('../../iris-user-management/user-management-home/user.component').then(
            (m) => m.UserComponent,
          ),
        path: 'people/home',
        title: 'User Management',
        providers: [
          USER_PROVIDER,
          WcgTableService,
          UserService,
          importProvidersFrom(
            EffectsModule.forFeature([UserManagementEffects]),
          ),
        ],
        resolve: {
          resolvedData: userResolver,
        },
      },
      // V1: Old module-based UserManagementHome (when USER_SITE_SERVICE_V2 is OFF)
      {
        canMatch: [
          negateGuard(canMatchUseSiteServiceV2),
          OktaAuthGuard,
          canMatchInternalUser,
          canMatchProfileComplete,
        ],
        loadChildren: () =>
          import('../../iris-user-management/iris-user-management.module').then(
            (m) => m.IrisUserManagementModule,
          ),
        path: 'people/home',
        title: 'User Management',
      },
    ],
    component: ProfilesPageComponent,
    path: '',
  },
];
